module.exports = __webpack_public_path__ + "resources/collaborative-whiteboard-78916c4ed1f0596672f0da8e5642bdfb.svg";